import http from "@/http-common";

export default class UserService {

	getList(_params) {
		return http.get('/cm/users', { params: _params}).then(res => res.data);
	}

	getOne(_username) {
		return http.get(`/cm/users/${_username}`).then(res => res.data);
	}

	getMine() {
		return http.get('/cm/users/mine').then(res => res.data);
	}

	insertOne(_data) {
		return http.post('/cm/users',_data).then(res => res.data);
	}

	updateOne(_Id,_data) {
		return http.patch(`/cm/users/${_Id}`.toString(), _data).then(res => res.data);
	}

	updateUserByAdmin(_Id,_data) {
		return http.patch(`/cm/users/update/${_Id}`.toString(), _data).then(res => res.data);
	}

	initPassword(_compSeq, _Id) {
		return http.patch(`/cm/users/initpassword/${_compSeq}/${_Id}`.toString()).then(res => res.data);
	}

	updatePassword(_Id, _oldPassword, _newPassword) {
		//alert('PW = ' + JSON.stringify(_newPassword));
		return http.patch(`/cm/users/password/${_Id}/${_oldPassword}/${_newPassword}`.toString()).then(res => res.data);
	}

	initPasswordAll(_compSeq) {
		return http.patch(`/cm/users/initPasswordAll/${_compSeq}`.toString()).then(res => res.data);
	}

	deleteOne(_compSeq, _userSeq)
	{
		return http.delete(`/cm/users/${_compSeq}/${_userSeq}`).then(res => res.data);
	}

	deleteList( _data)
	{
		return http.delete('/cm/users/', {data:JSON.stringify(_data)}).then(res => res.data);
	}

}